import { Injectable } from '@angular/core';
import { UserAgentService } from '../useragent/user-agent.service';

@Injectable()
export class ChatConfigurator {
    constructor() {
        if (UserAgentService.isIeLowerThan11()) {
            return;
        }

        this.configureZendeskChat();
    }

    private configureZendeskChat() {
        // Wait for Zopim to be loaded
        window.$zopim(() => {
            window.$zopim.livechat.setOnStatus(function (status) {
                if (window.innerWidth < 991) {
                    // small device as defined in functions.less
                    window.$zopim.livechat.window.hide();
                } else {
                    if (status === 'online') {
                        window.$zopim.livechat.badge.show();
                    } else {
                        window.$zopim.livechat.badge.hide();
                    }
                }
            });
        });
    }
}
